package com.vizio.redwolf.auth.api

import com.vizio.redwolf.auth.model.ApiFileLoggerLogLevel
import com.vizio.redwolf.auth.model.Endpoint
import com.vizio.redwolf.auth.model.HttpInfo
import com.vizio.redwolf.auth.model.buildHttpInfo
import com.vizio.redwolf.auth.model.secureEndpoints
import com.vizio.redwolf.auth.model.secureHeaders
import com.vizio.redwolf.utils.HttpRequestInfo
import io.ktor.client.statement.HttpResponse
import io.ktor.http.isSuccess

suspend fun logToFile(httpResponse: HttpResponse? = null, httpRequestInfo: HttpRequestInfo? = null, throwable: Throwable? = null) {
    val enableLog = when (ApiFileLogger.logLevel) {
        /**
         * Log on All scenarios
         */
        ApiFileLoggerLogLevel.ALL -> true
        /**
         * Log on ANY failure condition:
         * - Exception/throwable occurred
         * - No response at all (null)
         * - Response exists but is not success
         */
        ApiFileLoggerLogLevel.ERROR -> {
            throwable != null || httpResponse == null || httpResponse.status.isSuccess().not()
        }

        else -> false
    }

    if (enableLog) {
        val httpInfo = httpResponse?.buildHttpInfo() ?: httpRequestInfo?.buildHttpInfo()
        writeToFileLogger(httpInfo, throwable)
    }
}

private fun writeToFileLogger(httpInfo: HttpInfo?, throwable: Throwable? = null) {
    httpInfo?.let {
        // Do not log when it is success scenario with error log level but log for every other scenario
        ApiFileLogger.writeToFile("SDK: Request Host/Endpoint: ${httpInfo.url}")
        ApiFileLogger.writeToFile("SDK: Request Method: ${httpInfo.method}")
        ApiFileLogger.writeToFile("SDK: Request Headers:")
        httpInfo.requestHeaders.forEach { key, value ->
            if (secureHeaders.contains(key)) {
                ApiFileLogger.writeToFile("$key : **********")
            } else {
                ApiFileLogger.writeToFile("$key : $value")
            }
        }
        if (!secureEndpoints.contains(Endpoint(httpInfo.url.encodedPath, httpInfo.method))) {
            httpInfo.requestBody?.let {
                ApiFileLogger.writeToFile("SDK: Request Body: $it")
            }
        }

        httpInfo.responseStatusCode?.let { responseStatusCode ->
            ApiFileLogger.writeToFile("SDK: Response Status Code:  ${responseStatusCode.value}")
        }

        httpInfo.responseHeaders?.let { responseHeaders ->
            ApiFileLogger.writeToFile("SDK: Response Headers: $responseHeaders")
        }
        httpInfo.responseBody?.let { responseBody ->
            ApiFileLogger.writeToFile("SDK: Response Body: $responseBody")
        }
    }
    throwable?.let {
        ApiFileLogger.writeToFile("SDK: Response Exception: $throwable")
    }
}